<template>
  <section data-cy="unauthorized-section">
    <div class="text-center">
      <h1 data-cy="unauthorized-title">Unauthorized User</h1>
      <br />
      <p>
        Sorry, user "{{ email }}" is not authorized to use this application.
      </p>
      <p>
        Please contact your supervisor and ask them to add "{{ email }}" to the
        authorized users list.
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useLocalStorage } from "@vueuse/core";

const oktaToken = useLocalStorage("okta-token-storage", {
  idToken: { claims: { email: {} } }
});

const props = defineProps<{
  email: string;
}>();

const email = props.email || oktaToken.value.idToken.claims?.email || "unknown";
</script>
